module.exports = __webpack_public_path__ + "common/icon-select-arrow-color-key-f3161d431869a0ba17b74ef91978fc09.svg";